const isRecord = (value) => value !== null && typeof value === "object" && !Array.isArray(value);

const normalizeMoneyValue = (value) => {
  if (isRecord(value)) {
    if (value.amount !== undefined) return normalizeMoneyValue(value.amount);
    if (value.amount_minor !== undefined) {
      return Number.isFinite(Number(value.amount_minor))
        ? Number(value.amount_minor) / 100
        : null;
    }
    return null;
  }

  if (value === null || value === undefined || value === "") return value;
  const number = Number(value);
  return Number.isFinite(number) ? number : value;
};

const normalizeService = (value) => {
  if (!isRecord(value)) return value;

  const service = { ...value };
  if (service.defaultserviceprice === undefined && service.default_price !== undefined) {
    const price = normalizeMoneyValue(service.default_price);
    service.defaultserviceprice = price == null ? [] : [{ price }];
  }
  return service;
};

const normalizeServiceRelation = (value) => {
  if (!isRecord(value)) return value;

  const serviceSource = isRecord(value.services)
    ? value.services
    : isRecord(value.service)
      ? value.service
      : value;
  const service = normalizeService(serviceSource);
  const relation = { ...value, services: service };
  if (value.service !== undefined) relation.service = service;
  if (relation.qty === undefined && relation.quantity !== undefined) {
    relation.qty = relation.quantity;
  }
  return relation;
};

const normalizePaymentRows = (rows) => (
  Array.isArray(rows)
    ? rows.map((row) => (
      isRecord(row) && row.amount !== undefined
        ? { ...row, amount: normalizeMoneyValue(row.amount) }
        : row
    ))
    : rows
);

const normalizeSalon = (salon) => {
  if (!isRecord(salon)) return salon;
  return {
    ...salon,
    business_address: salon.business_address ?? salon.address,
    logo_url: salon.logo_url ?? salon.logo,
  };
};

export const normalizeSubscriptionDetailResponse = (response) => {
  if (!isRecord(response)) return response;

  const normalized = { ...response };
  ["amount", "one_off_amount"].forEach((field) => {
    if (Object.prototype.hasOwnProperty.call(response, field)) {
      normalized[field] = normalizeMoneyValue(response[field]);
    }
  });

  const relations = Array.isArray(response.subservice)
    ? response.subservice
    : Array.isArray(response.services)
      ? response.services
      : null;
  if (relations) normalized.subservice = relations.map(normalizeServiceRelation);
  if (response.salon !== undefined) normalized.salon = normalizeSalon(response.salon);
  if (response.payment !== undefined) normalized.payment = normalizePaymentRows(response.payment);
  if (response.payments !== undefined) normalized.payments = normalizePaymentRows(response.payments);
  return normalized;
};

export const normalizeSubscriptionInvoiceResponse = (response) => {
  const normalized = normalizeSubscriptionDetailResponse(response);
  if (!isRecord(normalized)) return normalized;

  if (isRecord(normalized.subscription)) {
    normalized.subscription = normalizeSubscriptionDetailResponse(normalized.subscription);
  }
  if (normalized.payment === undefined && normalized.payments !== undefined) {
    normalized.payment = normalized.payments;
  }
  return normalized;
};
